// src/pages/auth/FacebookCallback.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function FacebookCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Query string recibida:", location.search);
    const params = new URLSearchParams(location.search);
    // Intenta obtener el token con ambos nombres
    const accessToken = params.get("access_token");
    const jwt = params.get("jwt");
    const token = accessToken || jwt;
    const userType = params.get("userType"); // Si tu backend lo envía

    if (token) {
      localStorage.setItem("jwt", token);
      if (userType) {
        localStorage.setItem("userType", userType);
      }
      navigate("/mi-cuenta");
    } else {
      console.log("No se encontró token en la query string:", location.search);
      navigate("/login");
    }
  }, [location, navigate]);

  return (
    <div className="container my-5 text-center">
      <p>Procesando autenticación con Facebook...</p>
    </div>
  );
}

export default FacebookCallback;